import styled from '@emotion/styled';
import React from 'react';

import Account from './account';
import Organization from './organization';
import Primary from './primary';

import { LeftNavDrawer } from '~/client/components/base/left-nav';

interface Props {
  className?: string;
}

const LeftNavImpl: React.FC<Props> = ({ className }) => {
  return (
    <LeftNavDrawer className={className} initialRoute="primary">
      <Primary />
      <Organization />
      <Account />
    </LeftNavDrawer>
  );
};

const LeftNav = styled(LeftNavImpl)``;

export default LeftNav;
